module.exports = __webpack_public_path__ + "img/Owens_Logo.b81496b7.png";